<template>
  <div class="tab-slide" :style="{ padding: `${paddingSize}px` }">
    <div
      v-for="item in options"
      :key="item.key"
      class="tab-slide__item"
      :class="{ 'tab-slide__item--active': item.key === value }"
      @click="handleClick(item.key)"
    >
      <i v-if="item.icon" class="t-iconfont" :class="item.icon"></i>
      <span>{{ item.name }}</span>
      <img v-if="item.isBeta" class="ai-beta" :src="aiBeta" />
    </div>
  </div>
</template>

<script setup>
import aiBeta from '@/assets/ai-beta.png'

defineOptions({
  name: 'TabSlide'
})

const props = defineProps({
  options: {
    type: Array,
    default: () => []
  },
  value: {
    type: String,
    default: ''
  },
  paddingSize: {
    type: Number,
    default: 4
  }
})
const emit = defineEmits(['update:value', 'change'])

const handleClick = (val) => {
  if (val !== props.value) {
    emit('update:value', val)
    emit('change', val)
  }
}
</script>

<style lang="scss" scoped>
.tab-slide {
  flex: 0 0 auto;
  display: flex;
  position: relative;
  background: #f7f8fa;
  border-radius: 8px;
  width: max-content;
  .tab-slide__item {
    cursor: pointer;
    height: 32px;
    padding: 6px 12px;
    border-radius: 8px;
    transition: background 0.3s ease;
    color: #646566;
    font-size: 14px;
    display: flex;
    align-items: center;
    i {
      margin-right: 4px;
    }
    img {
      margin-left: 4px;
    }
  }
  .tab-slide__item--active {
    color: #323233;
    background: #ffffff;
  }
}
</style>
